import React,{useState,useEffect} from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import { FormControl } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  marginTop:3,
  borderRadius:1,
  outline:'none',
};

const theme = createTheme({
  palette: {
    neutral: {
      main: "#F0411A",
      contrastText: "#fff",
    },
  },
});

const UserListModaledit = ({render,setRender,item}) => {
  const [open, setOpen] = React.useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [university, setUniversity] = useState("");
  const [year, setYear] = useState("");
  const [password, setPassword] = useState("");
  // const [id, setId] = useState("");
  const handleOpen = (ids) => {
    // setId(ids);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);


  // const [age, setAge] = React.useState("");

  // const handleChange = (event) => {
  //   setAge(event.target.value);
  // };
  useEffect(() => {
    setName(item?.name);
    setEmail(item?.email);
    setUniversity(item?.university);
    setYear(item?.year);
    // setPassword(item?.password);
  }, [item]);

  const handleUpdatUser = async () => {
    // if (!checkboxObj) {
    //   toast.warning("please choose channel for the user");
    //   return;
    // }
    // if (!values.name) {
    //   toast.warning("please enter  name");
    //   return;
    // }
    // if (!values.phone) {
    //   toast.warning("please enter  phone");
    //   return;
    // }
    // if (!values.email) {
    //   toast.warning("please enter  email");
    //   return;
    // }
    // if (!values.password) {
    //   toast.warning("please enter  password");
    //   return;
    // }

    try {
      const res = await axios.patch(
        `api/v1/users/updateUser`,
        { name,email,university,year,password },
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            withCredentials: true,
            // Authorization: token,
          },
        }
      );
      console.log(res);
      if (res.status === 200 || res.statusText === "OK") {
        toast.success("success");
        setRender(!render);
        setName("");
        setEmail("");
        setUniversity("");
        setYear("");
        setPassword("");
        handleClose();
        return;
      }
    } catch (err) {
      // toast.error(err);
      console.log(err.response.data.message);
      // toast.error(err.response.data.message);
    }
  };

  return (
    <div>
      <ThemeProvider theme={theme}>
        {/* <Button variant="contained" color="neutral" onClick={handleOpen}>
          ပြင်ဆင်ရန်
        </Button> */}
        <EditIcon
          onClick={handleOpen}
          sx={{ color: "#686868", cursor: "pointer" }}
        />
      </ThemeProvider>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {/* <Typography id="modal-modal-title" variant="h6" component="h2">
            Create Two Digit Lucky Number
          </Typography> */}
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <TextField
              sx={{ width: "100%" }}
              id="outlined-search"
              label="Name"
              type="text"
              value={name}
              onChange={(e) => {
                setName(e.target.value);
              }}
            />
            <TextField
              sx={{ width: "100%", marginTop: 1 }}
              id="outlined-search"
              label="Email"
              type="email"
              value={email}
              onChange={(e)=>{
                setEmail(e.target.value);
              }}
            />
            <TextField
              sx={{ width: "100%", marginTop: 1 }}
              id="outlined-search"
              label="university"
              type="text"
              value={university}
              onChange={(e)=>{
                setUniversity(e.target.value);
              }}
            />
            <TextField
              sx={{ width: "100%", marginTop: 1 }}
              id="outlined-search"
              label="Year"
              type="number"
              value={year}
              onChange={(e)=>{
                setYear(e.target.value);
              }}
            />
            <TextField
              sx={{ width: "100%", marginTop: 1 }}
              id="outlined-search"
              label="Password"
              type="password"
              value={password}
              onChange={(e)=>{
                setPassword(e.target.value);
              }}
            />
            <ThemeProvider theme={theme}>
              <Button
                onClick={handleUpdatUser}
                sx={{ marginTop: 3, boxShadow: "none !important" }}
                variant="contained"
                color="neutral"
              >
                Update
              </Button>
            </ThemeProvider>
          </Typography>
        </Box>
      </Modal>
    </div>
  );
};

export default UserListModaledit;
